/** Суффикс «фейкового» email для Telegram-флоу (как в passport-client). */
export const FAKE_TELEGRAM_EMAIL_HOST = '@mitgo.telegram';

/** Суффикс «фейкового» email для телефонного флоу (как в passport-client). */
export const FAKE_PHONE_EMAIL_HOST = '@mitgo.phone';
